import type { ServiceProvider } from "@expert/service-providers";
import type { KyInstance } from "ky";

import { getFeature } from "@asurion-core/expert-workspace-feature-flagging";
import { getLogger } from "@expert/logging";
import { useQuery } from "@tanstack/react-query";

import type { AppConfig } from "../types";

const logger = getLogger({ module: "useAppConfigAndServiceProviderOverride" });
/** Can ONLY be used under the <AuthProvider> scope
 * Retrieves the app configuration (currently specific for service provider, like TwilioAppConfig)
 */
export const useAppConfigAndServiceProviderOverride = (
    api: KyInstance,
    employeeId: string | undefined,
    channel?: string,
) => {
    const { data, isLoading, error, status } = useQuery({
        queryKey: [`app-config`],
        queryFn: async () =>
            Promise.all([
                api.get("api/app-config").json<AppConfig>(),
                getFeature<ServiceProvider>("ServiceProviderOverride", {
                    employeeId,
                    channel,
                }),
            ]),
        retry: 0,
        refetchOnWindowFocus: false,
        enabled: !!employeeId,
    });
    if (data) {
        logger.debug("AppConfig received");
    }
    if (error) {
        logger.error({ error }, "Failed to fetch App Configuration");
    }
    return { data, isLoading, error, status };
};
